import { render } from "./ProductList.vue?vue&type=template&id=808d9a8c&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=808d9a8c&scoped=true&lang=css"
import "./ProductList.vue?vue&type=style&index=1&id=808d9a8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-808d9a8c"]])

export default __exports__